/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file LossHepatitisImmunityView.jsx
 * @author Daniel Aguirre
 * @description LossHepatitisImmunity View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DashboardCard from 'components/DashboardCard';
import { useHistory } from 'react-router';

import DashboardProgress from 'components/Charts/DashboardProgress';
import styleGuideColors from 'commons/styleGuideColors';

/**
 * LossHepatitisImmunity View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function LossHepatitisImmunityView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState([]);

  const { getLossHepatitisImmunity } = dashboardStaffActions;

  const onGetData = (_, resp) => {
    if (resp?.data) {
      const yes = resp.data.find((item) => item.clasificacion === 'Descendio');
      const no = resp.data.find(
        (item) => item.clasificacion === 'Sin registro o No Descendio'
      );
      const total = (yes?.cantidad || 0) + (no?.cantidad || 0);

      const data = {
        progress: yes
          ? {
              label: translate('dashboardStaff.patients'),
              title: yes.cantidad,
              value: ((yes.cantidad * 100) / total).toFixed(3).slice(0, -1),
              color: styleGuideColors.baxterBrandPurple,
              classification: yes.clasificacion,
              cantidad: yes.cantidad
            }
          : {},
        max: no
          ? {
              label: '',
              value: ((no.cantidad * 100) / total).toFixed(3).slice(0, -1),
              color: styleGuideColors.backgroundProgress
            }
          : {}
      };
      setChartData(data);
    }
  };

  useEffect(() => {
    getLossHepatitisImmunity({ clinicId }, onGetData);
  }, [translate]);

  const handleDetailClick = (section) => {
    const { cantidad: totalItems, classification } = chartData[section];
    history.push(
      `/main/dashboard-detail/loss-hepatitis-immunity/${classification}/${totalItems}`
    );
  };

  return (
    <DashboardCard id="F12" loading={chartData.length === 0}>
      <DashboardProgress
        title={translate('dashboardStaff.lossHepatitisImmunity')}
        description={translate(
          'dashboardStaff.lossHepatitisImmunityDescription'
        )}
        max={chartData.max}
        progress={chartData.progress}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
LossHepatitisImmunityView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getLossHepatitisImmunity: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default LossHepatitisImmunityView;
